import { Provider } from "@redotech/redo-order-common/provider";
import * as z from "zod";

export const RecognizeAudienceProduct = z.object({
  provider: z.enum(Provider),
  productId: z.string().min(1),
});

export type RecognizeAudienceProduct = z.infer<typeof RecognizeAudienceProduct>;

// Product-ID selections are still accepted from already-deployed clients.
export const RecognizeAudienceProductFilter = z.union([
  RecognizeAudienceProduct,
  z.object({ title: z.string().min(1) }),
]);

export type RecognizeAudienceProductFilter = z.infer<
  typeof RecognizeAudienceProductFilter
>;
